export const FONT_AWESOME_DEFAULT_PREFIX = 'fas';
